export const DICT = {
  title1: { hi: "महाकुंभ मेला 2025", en: "Maha Kumbh Mela 2025" },
  title2: {
    hi: "आईसीटी स्वच्छता/टेंटेज निगरानी प्रणाली",
    en: "ICT Sanitation and Tentage Monitoring System",
  },
  dashboard: {
    en: "Dashboard",
    hi: "डैशबोर्ड",
  },
  home: {
    hi: "मुख्य पृष्ठ",
    en: "Home",
  },
  reg_lost: {
    en: "Enroll Lost Person",
    hi: "खोया व्यक्ति पंजीकरण",
  },
  reg_found: {
    en: "Enroll Found Person",
    hi: "मिला व्यक्ति पंजीकरण",
  },
  sea_lost: {
    en: "Search Lost Person",
    hi: "खोए हुए व्यक्ति की खोज",
  },
  sea_found: {
    en: "Search Found Person",
    hi: "मिले  हुए व्यक्ति की खोजें",
  },

  emp_reg: {
    en: "User Registration",
    hi: "प्रयोगकर्ता पंजीकरण",
  },
  city_reg: {
    en: "Citizen Registration",
    hi: "नागरिक पंजीकरण",
  },
  help: {
    en: "Help",
    hi: "सहायता",
  },
  login: {
    en: "Login",
    hi: "लॉगिन",
  },
  logout: {
    en: "Logout",
    hi: "लॉगआउट",
  },
  register: {
    en: "Register",
    hi: "पंजीकृत करें",
  },
  search: {
    en: "Search",
    hi: "खोज",
  },
  user_reg: {
    en: "User Registration",
    hi: "उपयोगकर्ता पंजीकरण",
  },
  notice_board: {
    en: "Notice Board",
    hi: "सूचना बोर्ड",
  },
  translator: {
    en: "Translator",
    hi: "अनुवादक",
  },
  bring_fam: {
    en: "Reuniting Loved Ones, One Step at a Time",
    hi: "प्रियजनों को फिर से मिलाना, एक कदम एक बार में",
  },
  recent_load_found: {
    en: "Recent Lost & Found Cases",
    hi: "हाल की खोई और पाई गई घटनाएँ",
  },
  toll_free: {
    en: "24x7 Toll Free - 1920",
    hi: "24x7 टोल फ्री - 1920",
  },
  call_free: {
    en: "Call toll free number - 1231231232",
    hi: "टोल फ्री नंबर पर कॉल करें - 1231231232",
  },
  email: {
    en: "Email",
    hi: "ईमेल",
  },
  web_portal: {
    en: "Web Portal Visit",
    hi: "वेब पोर्टल पर जाएँ",
  },
  download_app: {
    en: "Download App",
    hi: "ऐप डाउनलोड करें",
  },
  statistics: {
    en: "Statistics",
    hi: "आंकड़े",
  },
  total_lost: {
    en: "Total Lost Persons Enrolled",
    hi: "कुल पंजीकृत खोए हुए व्यक्ति",
  },
  total_found: {
    en: "Total Found Persons Enrolled",
    hi: "कुल पंजीकृत मिले हुए व्यक्ति",
  },
  total_reunion: {
    en: "Total Reunion Completed",
    hi: "कुल पुनर्मिलन पूर्ण",
  },
  pending_cases: {
    en: "Pending Cases",
    hi: "लंबित मामले",
  },
  support_info: {
    en: "Support and Information",
    hi: "समर्थन और जानकारी",
  },
  city_corner: {
    en: "Citizen's Corner",
    hi: "नागरिक का कोना",
  },
  info_missing: {
    en: (
      <>
        <li className="hover:text-ec">Sector 14 -Near Bridge No. 14</li>
        <li className="hover:text-ec">
          Sector 17 - Near Police Chowki Central
        </li>
        <li className="hover:text-ec">Sector 17 - Near Police Post Utari</li>
        <li className="hover:text-ec">Sector 18 - Opposite Parmarth Niketan</li>
      </>
    ),
    hi: (
      <>
        <li> सेक्टर 14 -नियर पुल नं 14</li>
        <li> सेक्टर 17 -पुलिस चौकी मध्य के पास</li>
        <li> सेक्टर 17 -पुलिस चौकी उटारी के पास</li>
        <li> सेक्टर 18 -परमार्थ निकेतन के सामने</li>
      </>
    ),
  },
  info_found: {
    en: "Inform About Found Person",
    hi: "मिले हुए व्यक्ति की जानकारी दें",
  },
  useful_links: {
    en: "Useful Links",
    hi: "उपयोगी लिंक",
  },
  photo_missing_found: {
    en: "Photographs of Missing/Found Person",
    hi: "लापता/मिले हुए व्यक्ति की तस्वीरें",
  },
  check_status: {
    en: "Check The Status of Your Complaint of a Missing Person",
    hi: "लापता व्यक्ति की शिकायत की स्थिति जांचें",
  },
  quick_search: {
    en: "Quick Search",
    hi: "त्वरित खोज",
  },
  login_section: {
    en: "Login Section",
    hi: "लॉगिन अनुभाग",
  },
  police: {
    en: "Police",
    hi: "पुलिस",
  },
  mela_official: {
    en: "Mela Official",
    hi: "मेला अधिकारी",
  },
  lost_found_center: {
    en: "Lost & Found Centers",
    hi: "खोया और पाया केंद्र",
  },
  citizens: {
    en: "Citizens",
    hi: "नागरिक",
  },
  todays_statistics: {
    en: "Today's Statistics",
    hi: "आज की सांख्यिकी",
  },
  lost: {
    en: "Lost",
    hi: "खोया हुआ",
  },
  found: {
    en: "Found",
    hi: "मिला हुआ",
  },

  pending: {
    en: "Pending",
    hi: "लंबित",
  },
  reunion: {
    en: "Reunion",
    hi: "पुनर्मिलन",
  },
  info: {
    en: "Information",
    hi: "जानकारी",
  },
  objective: {
    en: "Objective",
    hi: "उद्देश्य",
  },
  local_help: {
    en: "Your Local Help",
    hi: "आपकी स्थानीय सहायता",
  },
  do_donts: {
    en: "Do's & Don'ts",
    hi: "क्या करें और क्या न करें",
  },
  web_links: {
    en: "Useful Links",
    hi: "उपयोगी लिंक",
  },
  kumbh_mela: {
    en: "Kumbhmela",
    hi: "कुंभ मेला",
  },
  up_police: {
    en: "UP Police",
    hi: "उत्तर प्रदेश पुलिस",
  },
  faq: {
    en: "FAQ",
    hi: "अक्सर पूछे जाने वाले प्रश्न",
  },
  community_forum: {
    en: "Community Forum",
    hi: "सामुदायिक मंच",
  },
  technical_support: {
    en: "Technical Support",
    hi: "तकनीकी सहायता",
  },
  citizen_feedback: {
    en: "Citizen Feedback",
    hi: "नागरिक प्रतिक्रिया",
  },
  contact: {
    en: "Contact",
    hi: "संपर्क",
  },
  address: {
    en: "Address",
    hi: "पता",
  },

  address_footer: {
    en: "Kumbh Mela Adhikari Triveni Bhawan, Prayagraj, Uttar Pradesh.",
    hi: "कुंभ मेला अधिकारी त्रिवेणी भवन, प्रयागराज, उत्तर प्रदेश।",
  },
  email_footer: {
    en: "support@kumbhtsmonitoring.in",
    hi: "support@kumbhtsmonitoring.in",
  },
  phone: { en: "Phone", hi: "फ़ोन" },
  phone_number: {
    en: "9763224602",
    hi: "9763224602",
  },
  emmergency: {
    en: "Emmergency",
    hi: "आपातकाल",
  },
  scan_qr: {
    en: "Scan QR",
    hi: "क्यूआर कोड स्कैन करें",
  },
  last_footer: {
    en: "Copyright © 2024 Kash IT Solutions Limited, Pune",
    hi: "कॉपीराइट © 2024 काश आईटी सॉल्यूशंस लिमिटेड, पुणे",
  },
  setting: {
    en: "Setting",
    hi: "सेटिंग",
  },
  name: {
    en: "Name",
    hi: "नाम",
  },
  age: {
    en: "Age",
    hi: "उम्र",
  },
  emmergency_no: {
    en: "Emergency No.",
    hi: "आपातकालीन नंबर",
  },
  ambulance: { hi: "एम्बुलेंस", en: "Ambulance" },
  fire: { hi: "आग", en: "Fire" },
  helpline: {
    en: "Helpline",
    hi: "हेल्पलाइन",
  },
  supportNo: {
    en: "Support No",
    hi: "समर्थन संख्या",
  },

  // ********************************
  role: {
    en: "Role",
    hi: "भूमिका",
  },
  manage_permissions: {
    en: "Manage Permissions",
    hi: "अनुमतियाँ प्रबंधित करें",
  },
  handover: {
    en: "Handover",
    hi: "हस्तांतरण",
  },
  handover_receipt: {
    en: "Handover Receipt",
    hi: "हस्तांतरण रसीद",
  },
  user: {
    en: "User",
    hi: "उपयोगकर्ता",
  },
  //Sanitation Dashboard And Vendor Dashboard
  sanitation_toilets_count: {
    en: "Sanitation Toilets Count",
    hi: "स्वच्छता शौचालय गिनती",
  },
  vehicle_count: {
    en: "Vehicle Count",
    hi: "वाहन गणना",
  },
  Partial_Complaint: {
    en: "Partial Complaint",
    hi: "आंशिक शिकायत",
  },
  complaint: {
    en: "Complaint",
    hi: "शिकायत",
  },
  not_Complaint: {
    en: "Not Complaint",
    hi: "सम्मत नहीं है",
  },
  total_toilets: {
    en: "Total Toilets",
    hi: "कुल शौचालय",
  },
  registered_toilets: {
    en: "Registered Toilets",
    hi: "पंजीकृत शौचालय",
  },
  total_registered: {
    en: "Total Registered",
    hi: "कुल पंजीकृत",
  },
  todays_registered: {
    en: "Today",
    hi: "आज",
  },
  todays_under_monitoring: {
    en: "Today",
    hi: "आज",
  },
  todays_monitoring: {
    en: "Today`s Monitoring",
    hi: "आज की निगरानी",
  },
  under_monitoring: {
    en: "Under Monitoring",
    hi: "निगरानी में",
  },
  off_monitoring: {
    en: "Off Monitoring",
    hi: "निगरानी बंद",
  },
  total_allocation: {
    en: "Total Allocation",
    hi: "कुल आवंटन",
  },
  number_of_toilets_cesspool: {
    en: "Number Of Toilets Cesspool Not Done In 24 Hrs",
    hi: "24 घंटे में नहीं बने शौचालयों की संख्या",
  },
  number_of_toilets_jetspray: {
    en: "Number Of Toilets JetSpray Not Deployed",
    hi: "शौचालयों की संख्या जेटस्प्रे तैनात नहीं",
  },
  number_of_toilets_manpower: {
    en: "Number Of Toilets Manpower Not Deployed",
    hi: "शौचालयों की संख्या, तैनात नहीं मानवशक्ति",
  },
  number_of_toilets_odor_free: {
    en: "Number Of Toilets Odor Free",
    hi: "गंध रहित शौचालयों की संख्या",
  },
  sanitation_toilet_details: {
    en: "Sanitation Toilet Details",
    hi: "स्वच्छता शौचालय विवरण",
  },
  clean: {
    en: "Clean",
    hi: "साफ",
  },
  unclean: {
    en: "Unclean",
    hi: "अशुद्ध",
  },
  maintenance_required: {
    en: "Maintenance Required",
    hi: "संरक्षण की आवश्यकता है",
  },
  no_data_available: {
    en: "No data available",
    hi: "कोई डेटा मौजूद नहीं",
  },
  see_more: {
    en: "See More",
    hi: "और देखें",
  },
  show_less: {
    en: "Show Less",
    hi: "कम दिखाएँ",
  },
  search: {
    en: "Search",
    hi: "खोज",
  },
  sectorwise_cleanliness_report: {
    en: "Sectorwise Cleanliness Report (Under Monitoring)",
    hi: "क्षेत्रवार स्वच्छता रिपोर्ट (निगरानी के तहत)",
  },
  select_zone: {
    en: "Select Zone",
    hi: "जोन चुनें",
  },
  select_circle: {
    en: "Select Circle",
    hi: "वृत्त का चयन करें",
  },
  high_priority: {
    en: "High Priority",
    hi: "उच्च प्राथमिकता",
  },
  low_priority: {
    en: "Low Priority",
    hi: "कम प्राथमिकता",
  },
  med_priority: {
    en: "Med Priority",
    hi: "मेड प्राथमिकता",
  },
  incident_report_analysis: {
    en: "Incident Report Analysis",
    hi: "घटना रिपोर्ट विश्लेषण",
  },
  sector_performance_overview: {
    en: "Sector Performance Overview",
    hi: "सेक्टर प्रदर्शन अवलोकन",
  },
  last_24_hrs: {
    en: "Last 24 Hrs",
    hi: "पिछले 24 घंटे",
  },
  vendor_performance_overview: {
    en: "Vendor Performance Overview",
    hi: "विक्रेता प्रदर्शन का अवलोकन",
  },
  high_performing_vendors: {
    en: "High Performing Vendors",
    hi: "उच्च प्रदर्शन करने वाले विक्रेता",
  },
  low_performing_vendors: {
    en: "Low Performing Vendors",
    hi: "कम प्रदर्शन करने वाले विक्रेता",
  },
  vendor: {
    en: "Vendor",
    hi: "विक्रेता",
  },
  task_done: {
    en: "Task Done",
    hi: "कार्य पूर्ण",
  },
  task_overdue: {
    en: "Task Overdue",
    hi: "कार्य विलंबित",
  },
  high_frequency_sector: {
    en: "High Frequency Sectors",
    hi: "उच्च आवृत्ति क्षेत्र",
  },
  high_performing_sector: {
    en: "High Performing Sectors",
    hi: "उच्च प्रदर्शन करने वाले क्षेत्र",
  },
  low_performing_sector: {
    en: "Low Performing Sectors",
    hi: "कम प्रदर्शन करने वाले क्षेत्र",
  },
  low_frequency_sector: {
    en: "Low Frequency Sectors",
    hi: "कम आवृत्ति क्षेत्र",
  },
  incidents: {
    en: "Incidents",
    hi: "घटनाएँ",
  },
  sector: {
    en: "Sector",
    hi: "क्षेत्र",
  },
  toilet: {
    en: "Toilet",
    hi: "शौचालय",
  },
  question: {
    en: "Question",
    hi: "सवाल",
  },
  location_of_sanitation: {
    en: "Locations Of Sanitation",
    hi: "स्वच्छता स्थान",
  },
  require_cleaning: {
    en: "Require Cleaning",
    hi: "साफ़ करने की आवश्यकता है",
  },
  cleaned: {
    en: "Cleaned",
    hi: "साफ़ किया गया",
  },
  under_maintenance: {
    en: "Under Maintenance",
    hi: "मरम्मत के अधीन",
  },
  select_toilet: {
    en: "Select Toilet",
    hi: "शौचालय चयन करें",
  },
  select_question: {
    en: "Select Question",
    hi: "प्रश्न चयन करें",
  },
  select_vendor: {
    en: "Select Vendor",
    hi: "विक्रेता चयन करें",
  },
  select_sector: {
    en: "Select Sector",
    hi: "क्षेत्र चयन करें",
  },
  total_incidents: {
    en: "Total Incidents",
    hi: "कुल घटनाएँ",
  },

  // tentage dashboard and furniture
  tentage_count: {
    en: "Tentage Count",
    hi: "तम्बू गिनती",
  },
  total_tentage: {
    en: "Total Tentage",
    hi: "कुल तम्बू",
  },
  registered_tentage: {
    en: "Registered Tentage",
    hi: "पंजीकृत तम्बू",
  },
  tentage_details: {
    en: "Tentage Details",
    hi: "तम्बू विवरण",
  },
  furniture_count: {
    en: "Furniture Count",
    hi: "फर्नीचर गिनती",
  },
  total_furniture: {
    en: "Total Furniture",
    hi: "कुल फर्नीचर",
  },
  registered_furniture: {
    en: "Registered Furniture",
    hi: "पंजीकृत फर्नीचर",
  },
  furniture_details: {
    en: "Furniture Details",
    hi: "फर्नीचर विवरण",
  },
  location_of_tents: {
    en: "Locations Of Tents",
    hi: "तंबू के स्थान",
  },
  require_attention: {
    en: "Require Attention",
    hi: "ध्यान देने की आवश्यकता है",
  },
  good: {
    en: "Good",
    hi: "अच्छा",
  },
  getToKnowUs: {
    en: "Get to Know Us",
    hi: "हमारे बारे में जानें",
  },
  aboutUs: {
    en: "About Us",
    hi: "हमारे बारे में",
  },
  termsConditions: {
    en: "Terms & Conditions",
    hi: "नियम एवं शर्तें",
  },
};

// *************Lnding Page**********

const langingPage = {
  reuniting_loved_ones: {
    en: "Reuniting Loved Ones",
    hi: "प्यारे लोगों को मिलाना",
  },
  maha_kumbh_mela_2025: {
    en: "Maha Kumbh Mela 2025",
    hi: "महाकुंभ मेला 2025",
  },
  prayagraj_kumbh_mela: {
    en: "Prayagraj Kumbh Mela",
    hi: "प्रयागराज कुंभ मेला",
  },
  helpline_no: {
    en: "Helpline No.",
    hi: "हेल्पलाइन नंबर",
  },
  kumbh_mela: {
    en: "Kumbh Mela",
    hi: "कुंभ मेला",
  },
  lost_found_tracking_system: {
    en: "Lost & Found Tracking System",
    hi: "खोया और पाया ट्रैकिंग प्रणाली",
  },
  stay_connected_kumbh_mela: {
    en: "Stay connected and ensure the safety of your loved ones during the Kumbh Mela. If you've lost someone or something, we're here to assist. Call our dedicated helpline for immediate help.",
    hi: "कुंभ मेला के दौरान अपने प्रियजनों की सुरक्षा सुनिश्चित करें और जुड़े रहें। यदि आपने किसी को या किसी चीज़ को खो दिया है, तो हम यहाँ सहायता के लिए हैं। तत्काल सहायता के लिए हमारी समर्पित हेल्पलाइन पर कॉल करें।",
  },
  todays_lost_persons_enrolled: {
    en: "Today's Lost Persons Enrolled",
    hi: "आज के खोए हुए व्यक्ति पंजीकृत",
  },
  todays_found_persons_enrolled: {
    en: "Today's Found Persons Enrolled",
    hi: "आज के पाए गए व्यक्ति पंजीकृत",
  },
  todays_reunion_completed: {
    en: "Today's Reunion Completed",
    hi: "आज की पुनर्मिलन पूरी हुई",
  },
  todays_pending: {
    en: "Today's Pending",
    hi: "आज के लंबित",
  },
  cases: {
    en: "Cases",
    hi: "मामले",
  },
  percent_no_change: {
    en: "% No Change",
    hi: "% कोई बदलाव नहीं",
  },
  percent_lower_than_yesterday: {
    en: "% Lower Than Yesterday",
    hi: "% कल से कम",
  },
  percent_higher_than_yesterday: {
    en: "% Higher Than Yesterday",
    hi: "% कल से अधिक",
  },
  total_reports_enrolled: {
    en: "Total Reports Enrolled",
    hi: "कुल रिपोर्ट पंजीकृत",
  },
  total_reunite_cases: {
    en: "Total Reunite Cases",
    hi: "कुल पुनर्मिलन मामले",
  },
  total_unresolved_cases: {
    en: "Total Unresolved Cases",
    hi: "कुल अपठित मामले",
  },
  average_time_to_resolve_case: {
    en: "Average Time to Resolve Case",
    hi: "मामला हल करने का औसत समय",
  },
  total_lost: {
    en: "Total Lost",
    hi: "कुल खोए हुए",
  },
  total_found: {
    en: "Total Found",
    hi: "कुल पाए गए",
  },
  reunite: {
    en: "Reunite",
    hi: "पुनर्मिलन",
  },
  unresolved: {
    en: "Unresolved",
    hi: "अनसुलझा",
  },
  recent_load_found: {
    en: "Recent Lost & Found Cases",
    hi: "हाल की खोई और पाई गई घटनाएँ",
  },
  total_lost_persons_enrolled: {
    en: "Total Lost Persons Enrolled",
    hi: "कुल खोए हुए व्यक्ति पंजीकृत",
  },
  values: {
    en: "Values",
    hi: "मूल्य",
  },
  last_three_days_comparison: {
    en: "Last Three Days Comparison",
    hi: "पिछले तीन दिनों की तुलना",
  },
  case_count: {
    en: "Case Count",
    hi: "मामलों की संख्या",
  },
  sun: {
    en: "Sun",
    hi: "रविवार",
  },
  mon: {
    en: "Mon",
    hi: "सोमवार",
  },
  tue: {
    en: "Tue",
    hi: "मंगलवार",
  },
  wed: {
    en: "Wed",
    hi: "बुधवार",
  },
  thur: {
    en: "Thur",
    hi: "गुरुवार",
  },
  fir: {
    en: "Fri",
    hi: "शुक्रवार",
  },
  sat: {
    en: "Sat",
    hi: "शनिवार",
  },
  lost_cases: {
    en: "Lost Cases",
    hi: "खोए हुए मामले",
  },
  found_cases: {
    en: "Found Cases",
    hi: "पाए गए मामले",
  },
  reunite_cases: {
    en: "Reunite Cases",
    hi: "पुनर्मिलन मामले",
  },
  unresolved_cases: {
    en: "Unresolved Cases",
    hi: "अनसुलझे मामले",
  },
  locations_of_lost_and_found_cases: {
    en: "Locations of Lost and Found Cases",
    hi: "खोए और पाए गए मामलों के स्थान",
  },
  high_density_found: {
    en: "High Density Found",
    hi: "उच्च घनत्व पाए गए",
  },
  high_density_lost: {
    en: "High Density Lost",
    hi: "उच्च घनत्व खोए हुए",
  },
  citizen: {
    en: "Citizen",
    hi: "नागरिक",
  },
  user: {
    en: "User",
    hi: "उपयोगकर्ता",
  },
  name: {
    en: "Name",
    hi: "नाम",
  },
  email: {
    en: "Email",
    hi: "ईमेल",
  },
  phone: {
    en: "Phone",
    hi: "फ़ोन",
  },
  selectRole: {
    en: "Select Role",
    hi: "भूमिका चुनें",
  },
  roleRequired: {
    en: "Please select role!",
    hi: "कृपया भूमिका चुनें!",
  },
  name: {
    en: "Name",
    hi: "नाम",
  },
  phone: {
    en: "Phone",
    hi: "फ़ोन",
  },
  photo: {
    en: "Photo",
    hi: "फ़ोटो",
  },
  role: {
    en: "Role",
    hi: "भूमिका",
  },
  center: {
    en: "Center",
    hi: "केंद्र",
  },
  address: {
    en: "Address",
    hi: "पता",
  },
  action: {
    en: "Action",
    hi: "क्रिया",
  },
  reset: {
    en: "Reset",
    hi: "रीसेट",
  },
  search: {
    en: "Search",
    hi: "खोज",
  },
  total: {
    en: "Total",
    hi: "कुल",
  },
  manage_permissions: {
    en: "Manage Permissions",
    hi: "अनुमतियाँ प्रबंधित करें",
  },
  select_role: {
    en: "Select Role",
    hi: "भूमिका चुनें",
  },
  module: {
    en: "Module",
    hi: "मॉड्यूल",
  },
  update: {
    en: "Update",
    hi: "अपडेट करें",
  },
  handover: {
    en: "Handover",
    hi: "हस्तांतरण",
  },
  ticket_number: {
    en: "Ticket Number",
    hi: "टिकट संख्या",
  },
  first_name: {
    en: "First Name",
    hi: "पहला नाम",
  },
  last_name: {
    en: "Last Name",
    hi: "अंतिम नाम",
  },
  age: {
    en: "Age",
    hi: "आयु",
  },
  center: {
    en: "Center",
    hi: "केंद्र",
  },
  date_of_birth: {
    en: "Date of Birth",
    hi: "जन्म तिथि",
  },
  gender: {
    en: "Gender",
    hi: "लिंग",
  },
  complainant_phone_number: {
    en: "Complainant Phone Number",
    hi: "शिकायतकर्ता का फोन नंबर",
  },
  complainant_name: {
    en: "Complainant Name",
    hi: "शिकायतकर्ता का नाम",
  },
  receiver_information: {
    en: "Receiver Information",
    hi: "प्राप्तकर्ता जानकारी",
  },
  date: {
    en: "Date",
    hi: "तारीख",
  },
  relation: {
    en: "Relation",
    hi: "संबंध",
  },
  phone_number: {
    en: "Phone Number",
    hi: "फोन नंबर",
  },
  enter_ticket_number: {
    en: "Enter Ticket Number",
    hi: "टिकट संख्या दर्ज करें",
  },
  enter_center_number: {
    en: "Enter Center Number",
    hi: "केंद्र संख्या दर्ज करें",
  },
  enter_name: {
    en: "Enter Name",
    hi: "नाम दर्ज करें",
  },
  enter_phone_number: {
    en: "Enter Phone Number",
    hi: "फोन नंबर दर्ज करें",
  },
  enter_complainant_name: {
    en: "Enter Complainant Name",
    hi: "शिकायतकर्ता का नाम दर्ज करें",
  },
  select_gender: {
    en: "Select Gender",
    hi: "लिंग चुनें",
  },
  select_relation: {
    en: "Select Relation",
    hi: "संबंध चुनें",
  },
  select_date: {
    en: "Select Date",
    hi: "तारीख चुनें",
  },
  enter_address: {
    en: "Enter Address",
    hi: "पता दर्ज करें",
  },
  enter_phone_number: {
    en: "Enter Phone Number",
    hi: "फोन नंबर दर्ज करें",
  },
  submit: {
    en: "Submit",
    hi: "जमा करें",
  },
  lost_and_found_search: {
    en: "Lost & Found Search",
    hi: "खोए और पाए गए की खोज",
  },
  male: {
    en: "Male",
    hi: "पुरुष",
  },
  female: {
    en: "Female",
    hi: "महिला",
  },
  lost_persons: {
    en: "Lost Persons",
    hi: "खोए हुए व्यक्ति",
  },
  found_persons: {
    en: "Found Persons",
    hi: "पाए गए व्यक्ति",
  },
  please_enter_info_to_search: {
    en: "Please enter some information to perform the search.",
    hi: "खोज करने के लिए कृपया कुछ जानकारी दर्ज करें।",
  },
  note: {
    en: "Note",
    hi: "नोट",
  },
  please_enter_ticket_number: {
    en: "Please enter the ticket number",
    hi: "कृपया टिकट संख्या दर्ज करें",
  },
  please_select_date: {
    en: "Please select the date",
    hi: "कृपया तारीख चुनें",
  },
  please_enter_relation: {
    en: "Please enter relation",
    hi: "कृपया संबंध दर्ज करें",
  },
  please_enter_receiver_name: {
    en: "Please enter receiver name",
    hi: "कृपया प्राप्तकर्ता का नाम दर्ज करें",
  },
  please_select_gender: {
    en: "Please select gender",
    hi: "कृपया लिंग चुनें",
  },
  please_enter_phone_number: {
    en: "Please enter phone number",
    hi: "कृपया फोन नंबर दर्ज करें",
  },
  please_select_dob: {
    en: "Please select DOB",
    hi: "कृपया जन्म तिथि चुनें",
  },
  please_enter_address: {
    en: "Please enter address",
    hi: "कृपया पता दर्ज करें",
  },
  please_select_gender: {
    en: "Please select gender",
    hi: "कृपया लिंग चुनें",
  },
  please_update_permissions: {
    en: "Please update some permissions!",
    hi: "कृपया कुछ अनुमतियाँ अपडेट करें!",
  },
  update_user_details: {
    en: "Update User Details",
    hi: "उपयोगकर्ता विवरण अपडेट करें",
  },
  all_mandatory_fields: {
    en: "All * marks fields are mandatory",
    hi: "सभी * चिह्नित फ़ील्ड अनिवार्य हैं",
  },
  select_role: {
    en: "Select Role",
    hi: "भूमिका चुनें",
  },
  select_center: {
    en: "Select Center",
    hi: "केंद्र चुनें",
  },
  email_id: {
    en: "Email ID",
    hi: "ईमेल आईडी",
  },
  upload_photo: {
    en: "Upload Photo",
    hi: "फ़ोटो अपलोड करें",
  },
  update: {
    en: "Update",
    hi: "अपडेट करें",
  },
  please_select_center: {
    en: "Please select center!",
    hi: "कृपया केंद्र चुनें!",
  },
  user_registration: {
    en: "User Registration",
    hi: "उपयोगकर्ता पंजीकरण",
  },
  register: {
    en: "Register",
    hi: "पंजीकरण करें",
  },
  create_role: {
    en: "Create Role",
    hi: "भूमिका बनाएं",
  },
  role_name: {
    en: "Role Name",
    hi: "भूमिका का नाम",
  },
  please_enter_role_name: {
    en: "Please enter role name!",
    hi: "कृपया भूमिका का नाम दर्ज करें!",
  },
  center_registration: {
    en: "Center Registration",
    hi: "केंद्र पंजीकरण",
  },
  center_name: {
    en: "Center Name",
    hi: "केंद्र का नाम",
  },
  center_type: {
    en: "Center Type",
    hi: "केंद्र का प्रकार",
  },
  select_sector: {
    en: "Select Sector",
    hi: "क्षेत्र चुनें",
  },
  select_center_type: {
    en: "Select Center Type",
    hi: "केंद्र प्रकार चुनें",
  },
  center_address: {
    en: "Center Address",
    hi: "केंद्र का पता",
  },
  please_enter_center_name: {
    en: "Please enter center name!",
    hi: "कृपया केंद्र का नाम दर्ज करें!",
  },
  please_enter_center_type: {
    en: "Please enter Center Type!",
    hi: "कृपया केंद्र प्रकार दर्ज करें!",
  },
  please_select_sector: {
    en: "Please Select Sector!",
    hi: "कृपया क्षेत्र चुनें!",
  },
  please_enter_address_name: {
    en: "Please enter address name!",
    hi: "कृपया पता नाम दर्ज करें!",
  },
  enter_email: {
    en: "Enter email",
    hi: "ईमेल दर्ज करें",
  },
  enter_password: {
    en: "Enter password",
    hi: "पासवर्ड दर्ज करें",
  },
  please_select_role: {
    en: "Please select role!",
    hi: "कृपया भूमिका चुनें!",
  },
  please_enter_name: {
    en: "Please enter name!",
    hi: "कृपया नाम दर्ज करें!",
  },
  please_enter_email: {
    en: "Please enter the email",
    hi: "कृपया ईमेल दर्ज करें",
  },
  please_enter_password: {
    en: "Please enter the password",
    hi: "कृपया पासवर्ड दर्ज करें",
  },
  please_enter_valid_name: {
    en: "Please enter a valid name!",
    hi: "कृपया एक मान्य नाम दर्ज करें!",
  },
  please_enter_valid_email: {
    en: "Please enter a valid email",
    hi: "कृपया एक मान्य ईमेल दर्ज करें",
  },
  please_enter_valid_phone_number: {
    en: "Please enter a valid 10-digit phone number",
    hi: "कृपया एक मान्य 10-अंकीय फोन नंबर दर्ज करें",
  },
  password_minimum_length: {
    en: "Password must be at least 6 characters long",
    hi: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
  },
  invalid_mobile_number: {
    en: "Invalid mobile number. It must be exactly 10 digits long.",
    hi: "अमान्य मोबाइल नंबर। यह ठीक 10 अंकों का होना चाहिए।",
  },
  other: {
    en: "Other",
    hi: "अन्य",
  },
  friend: {
    en: "Friend",
    hi: "मित्र",
  },
  family: {
    en: "Family",
    hi: "परिवार",
  },
  add_center: {
    en: "Add Center",
    hi: "केंद्र जोड़ें",
  },
};

export { langingPage };
